/*
* @Author: ssxu9
* @Date:   2016-04-04 21:10:25
* @Last Modified by:   ssxu9
* @Last Modified time: 2016-04-04 21:42:10
*/
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import createLogger from 'vuex/logger'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        user
    },
    strict: debug,
    moddlewares: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/vuex/store.js